import { render, staticRenderFns } from "./CommunityForm.vue?vue&type=template&id=96d31a08&scoped=true"
import script from "./CommunityForm.vue?vue&type=script&lang=js"
export * from "./CommunityForm.vue?vue&type=script&lang=js"
import style0 from "./CommunityForm.vue?vue&type=style&index=0&id=96d31a08&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d31a08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96d31a08')) {
      api.createRecord('96d31a08', component.options)
    } else {
      api.reload('96d31a08', component.options)
    }
    module.hot.accept("./CommunityForm.vue?vue&type=template&id=96d31a08&scoped=true", function () {
      api.rerender('96d31a08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/components/form/CommunityForm.vue"
export default component.exports